import React, { Component } from 'react';
import axios from 'axios';
import { API_URL } from './partials/Globals';
import LoginFooterNavigation from './partials/LoginFooterNavigation';
import logo from '../img/energyaid.png';
import Message from './partials/Message';
import Errors from './partials/Errors';

class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            email: '',
            emailHasBeenSent: false,
            errors: '',
            message: ''
        };

        this.inputChange = this.inputChange.bind(this);
        this.sendForm = this.sendForm.bind(this);
    }

    componentWillMount() {
        document.getElementById('body').className='dark';
    }

    inputChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    sendForm(event) {
        event.preventDefault();

        axios.post(API_URL+'/auth/forgot-password', { 
            email: this.state.email
        })
        .then(response => {
            this.setState({ message: 'Ett mail har skickats!' });
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                this.setState({ errors: error.response.data }); 
            }
            // Annat fel
            if (error.response && error.response.status === 400) {
                this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    render() {

        return (
            <div>
                <div className="masthead">
                    <img src={ logo } alt="EnergyAid" />  
                </div>

                <Message message={ this.state.message } />
                <Errors errors={ this.state.errors } />

                <div className="container">
                    <div className="col-12">
                        <h1>Glömt lösenord</h1>
                        <form onSubmit={ this.sendForm }>
                            <input type="email" className="text-center" required name="email" value={ this.state.email } placeholder="Din e-postadress" onChange={ this.inputChange } />
                            <input type="submit" className="button green" value="Skicka länk" />
                        </form>

                        <LoginFooterNavigation />
                    </div>
                </div>
            </div>
        )
    }
}

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js